(function() {
    angular
        .module("wzModule", [
            "ui.router",
            "googlechart",
            "ui.calendar"
        ])
})()
